import { ProductDetail } from "../../../../../graphql/operations";
import Chapter from "./Chapter";
import styles from "./Story.module.css";

interface Props {
  details?: ProductDetail[];
}

export default function Story({ details }: Props) {
  return details ? (
    <div className={styles.DetailPartsStory}>
      {details.map((detail, index) => {
        return (
          detail && (
            <div key={index}>
              <Chapter detail={detail} />
            </div>
          )
        );
      })}
    </div>
  ) : null;
}
